export const drawRadiusRect = function(ctx, x, y, w, h, r) {
    const br = r
    ctx.beginPath()
    ctx.moveTo(x + br, y)
    ctx.lineTo(x + w - br, y)
    ctx.arc(x + w - br, y + br, br, 2 * Math.PI * (3 / 4), 2 * Math.PI * (4 / 4))
    ctx.lineTo(x + w, y + h)
    ctx.lineTo(x, y + h)
    ctx.lineTo(x, y + br)
    ctx.arc(x + br, y + br, br, 2 * Math.PI * (2 / 4), 2 * Math.PI * (3 / 4))
}
export const drawText = function({
    ctx,
    textStrs,
    color = '#1f1f1f',
    font = 'normal bold 44px PingFang SC',
    rowNum = 3,
    rowTop = 489,
    rowLh = 64,
    rowLeft = 72,
    rowWidth = 612
}, cb) {
    ctx.setFillStyle(color)
    ctx.font = font
    ctx.textBaseline = 'top'
    let text = textStrs.trim()
    let row = []
    let row_top = rowTop
    let row_left = rowLeft
    const paragraphs = text.split(/[↵\r\n]/).filter(v => v)
    paragraphs.forEach((paragraph) => {
        let temp = ''
        for (let i = 0; i < paragraph.length; i++) {
            if (ctx.measureText(temp).width < rowWidth) {
                temp += paragraph[i]
            }
            else {
                i--
                row.push(temp)
                temp = ''
            }
        }
        row.push(temp);
    })
    if (row.length > rowNum) {
        let rowCut = row.slice(0, rowNum)
        let rowPart = rowCut[rowNum - 1]
        let test = ''
        let empty = []
        for (let a = 0; a < rowPart.length; a++) {
            if (ctx.measureText(test).width < 590) {
                test += rowPart[a]
            }
            else {
                break
            }
        }
        empty.push(test)
        let group = empty[0] + '...'
        rowCut.splice(rowNum - 1, 1, group)
        row = rowCut
    }
    for (let b = 0; b < row.length; b++) {
        if (b > 0) {
            row_top += rowLh
        }
        ctx.fillText(row[b], row_left, row_top, rowWidth)
    }
    cb && cb(row_top, row.length)
}

export const drawArc = (ctx, {x, y, r, fillStyle}) => {
    ctx.beginPath()
    ctx.arc(x, y, r, 0, 2 * Math.PI, false)
    ctx.fillStyle = fillStyle
    ctx.fill()
    ctx.closePath()
}

export const drawConsultantCard = (ctx, {
    headImage,
    headImageBg,
    name,
    houseName,
    wx,
    tel,
    tag,
    tagBg,
    qr,
    qrBg,
    qrLabel
}) => {
    ctx.textBaseline = 'top'
    ctx.save()
    // draw headimg
    const headImageBg_center_x = headImage.x + headImage.r
    const headImageBg_center_y = headImage.y + headImage.r
    drawArc(ctx, {
        x: headImageBg_center_x,
        y: headImageBg_center_y,
        r: headImageBg.r,
        fillStyle: headImageBg.fillStyle
    })
    ctx.restore()
    ctx.save()
    ctx.beginPath()
    ctx.arc(headImageBg_center_x, headImageBg_center_y, headImage.r, 0, 2 * Math.PI)
    ctx.closePath()
    ctx.clip()
    ctx.drawImage(headImage.path, headImage.x, headImage.y, headImage.r * 2, headImage.r * 2)
    ctx.restore()

    // draw name
    ctx.save()
    ctx.setFillStyle(name.color)
    ctx.font = name.font
    // ctx.textAlign = 'center'
    ctx.fillText(name.text, name.x, name.y)
    ctx.restore()
    const name_w = ctx.measureText(name.text).width
    // draw tagBg
    ctx.save()
    ctx.font = tag.font
    const tagBg_w = ctx.measureText(tag.text).width + 12
    const tagBg_x = headImage.x + headImage.r * 2 + headImage.marginR + tagBg.marginL + name_w
    ctx.fillStyle = tagBg.color
    ctx.fillRect(tagBg_x, tagBg.y, tagBg_w, tagBg.h)
    ctx.restore()

    // draw tag
    ctx.save()
    ctx.textBaseline = 'middle'
    ctx.setFillStyle(tag.color)
    ctx.font = tag.font
    ctx.textAlign = 'center'
    ctx.fillText(tag.text, tagBg_x + tagBg_w / 2, tagBg.y + tagBg.h / 2)
    ctx.restore()

    // draw house name
    ctx.save()
    ctx.setFillStyle(houseName.color)
    ctx.font = houseName.font
    let detail_y = name.y + name.LH + houseName.marginT
    ctx.fillText(houseName.text, houseName.x, detail_y)
    ctx.restore()

    // draw wx
    ctx.save()
    ctx.setFillStyle(wx.color)
    ctx.font = wx.font
    detail_y += wx.marginT + houseName.LH
    ctx.fillText(wx.text, wx.x, detail_y)
    ctx.restore()

    // draw tel
    ctx.save()
    ctx.setFillStyle(tel.color)
    ctx.font = tel.font
    detail_y += tel.marginT + wx.LH
    ctx.fillText(tel.text, tel.x, detail_y)
    ctx.restore()

    // draw qr
    ctx.save()
    const qrBg_center_x = qr.x + qr.r
    const qrBg_center_y = qr.y + qr.r
    drawArc(ctx, {
        x: qrBg_center_x,
        y: qrBg_center_y,
        r: qrBg.r,
        fillStyle: qrBg.fillStyle
    })
    ctx.restore()
    ctx.save()
    ctx.beginPath()
    ctx.arc(qrBg_center_x, qrBg_center_y, qr.r, 0, 2 * Math.PI)
    ctx.closePath()
    ctx.clip()
    ctx.drawImage(qr.path, qr.x, qr.y, qr.r * 2, qr.r * 2)
    ctx.restore()

    // draw qrLabel
    ctx.save()
    ctx.setFillStyle(qrLabel.color)
    ctx.font = qrLabel.font
    ctx.textAlign = 'center'
    ctx.fillText(qrLabel.text, qrBg_center_x, qrBg_center_y + qrBg.r + 10)
    ctx.restore()
}

export const drawCircleRadius = (ctx, {style, left, top, width, height, radius, line}) => {
    ctx.beginPath()
    ctx.setLineWidth(line)
    ctx.strokeStyle = style
    ctx.arc(left + radius, top + radius, radius * 2, 1 * Math.PI, 1.5 * Math.PI)
    ctx.arc(left + width - radius, top + radius, radius * 2, 1.5 * Math.PI, 2 * Math.PI)
    ctx.arc(left + width - radius, top + height - radius, radius * 2, 0, .5 * Math.PI)
    ctx.arc(left + radius, top + height - radius, radius * 2, .5 * Math.PI, 1 * Math.PI)
    ctx.lineTo(left - radius, top + radius)
    ctx.stroke()
    ctx.restore()
}

export const strokeRectWidthRadius = (ctx, {
    line_width,
    stroke_style,
    fill_style,
    width,
    height,
    left,
    top,
    radius,
    clip = false
}) => {
    ctx.save()
    ctx.beginPath()
    if (line_width) {
        ctx.setLineWidth(line_width)
    }
    if (fill_style) {
        ctx.setFillStyle(fill_style)
    }
    if (stroke_style) {
        ctx.strokeStyle = stroke_style
    }
    ctx.arc(left + radius, top + radius, radius * 2, 1 * Math.PI, 1.5 * Math.PI)
    ctx.arc(left + width - radius, top + radius, radius * 2, 1.5 * Math.PI, 2 * Math.PI)
    ctx.arc(left + width - radius, top + height - radius, radius * 2, 0, .5 * Math.PI)
    ctx.arc(left + radius, top + height - radius, radius * 2, .5 * Math.PI, 1 * Math.PI)
    ctx.lineTo(left - radius, top + radius)

    if (stroke_style) {
        ctx.stroke()
    }
    if (fill_style) {
        ctx.fill()
    }
    ctx.closePath()
    if (clip) {
        ctx.clip()
    }
    ctx.restore()
}

export const drawCircleImg = (ctx, {
    img,
    left,
    top,
    size,
    stroke_style,
    line_width
}) => {
    const radius = size / 2

    ctx.save()
    if (line_width) {
        ctx.setLineWidth(line_width)
    }
    if (stroke_style) {
        ctx.strokeStyle = stroke_style
    }
    ctx.beginPath()
    ctx.arc(left + radius, top + radius, radius, 0, 2 * Math.PI)
    ctx.closePath()
    if (stroke_style) {
        ctx.stroke()
    }
    ctx.clip()
    ctx.drawImage(img, left, top, size, size)
    ctx.restore()
}